import { Field } from "@lib/shared/types";
import React, { ReactElement } from "react";
import styles from "./styles.module.scss";

interface InputProps {
    field: Field;
    onChange: (val: string) => void;
    onBlur: (val: string) => void;
    value: string;
    className: string;
}

export default function TextArea(props: InputProps): ReactElement {
    const { value, onChange, onBlur, field, className } = props;
    const { maxValue, minValue } = field;

    const maxLength =
        maxValue?.type === "number" && maxValue.value != null
            ? parseInt(String(maxValue.value), 10)
            : undefined;

    const minLength =
        minValue?.type === "number" && minValue.value != null
            ? parseInt(String(minValue.value), 10)
            : undefined;

    return (
        <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            className={`${styles["field"]} ${styles["textarea"]} ${
                className ?? ""
            }`}
            placeholder={field.placeholder ?? undefined}
            onBlur={(e) => onBlur(e.target.value)}
            maxLength={Number.isNaN(maxLength) ? undefined : maxLength}
            minLength={Number.isNaN(minLength) ? undefined : minLength}
            rows={5}
            id={field.codeName}
        />
    );
}
